import React from 'react';
import PropTypes from 'prop-types';
import { contextCompany } from 'context';
import Lottie from 'lottie-react';
import { Button, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import celebration from './lottie/celebration.json';

const Success = ({ reset }) => {
 const { setStep, setUser } = contextCompany();
 const navigate = useNavigate();

 const emptyData = () => {
  //localStorage.setItem('sesion', JSON.stringify(dataAuth));
  //const sessions = JSON.parse(localStorage.getItem('sessions')) || [];
  //const isSession = sessions.some(t => t.email === dataAuth.email);
  //!isSession && sessions.unshift(dataAuth);
  //localStorage.setItem('sessions', JSON.stringify(sessions));
  //toast.success(`Conectado como ${dataAuth.email} 👌`);

  navigate('/authentication/card/login');
  setStep(1);
  setUser({});
  reset();
 };

 return (
  <>
   <Row>
    <Col className="text-center">
     <div className="wizard-lottie-wrapper">
      <div className="wizard-lottie mx-auto">
       <Lottie animationData={celebration} loop={true} />
      </div>
     </div>
     <h4 className="mb-1">¡Tu cuenta está lista!</h4>
     <p className="fs-0">Ahora puedes acceder a tu cuenta</p>
     <Button color="primary" className="px-5 my-3" onClick={emptyData}>
      Iniciar
     </Button>
    </Col>
   </Row>
  </>
 );
};

Success.propTypes = {
 reset: PropTypes.func.isRequired
};

export default Success;
